// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3M7yI","productName":"Table_productName__igmkj"};